const ourValuesData = [
  {
    id: "1",
    icon: require("../../assets/icons/Integrity.svg").default,
    title: "Integrity",
    details:
      "We uphold the highest ethical standards in all our professional dealings and client relationships.",
  },
  {
    id: "2",
    icon: require("../../assets/icons/Excellence.svg").default,
    title: "Excellence",
    details:
      "We strive for excellence in every service we provide, ensuring quality and precision in our work.",
  },
  {
    id: "3",
    icon: require("../../assets/icons/Collaboration.svg").default,
    title: "Collaboration",
    details:
      "We believe in the power of teamwork and collaborative partnerships with our clients.",
  },
  {
    id: "4",
    icon: require("../../assets/icons/Innovation.svg").default,
    title: "Innovation",
    details:
      "We embrace innovative solutions and modern approaches to traditional accounting challenges.",
  },
  {
    id: "5",
    icon: require("../../assets/icons/ClientFocus.svg").default,
    title: "Client Focus",
    details:
      "Our clients' success is our primary motivation, driving everything we do.",
  },
  {
    id: "6",
    icon: require("../../assets/icons/ProfessionalGrowth.svg").default,
    title: "Professional Growth",
    details:
      "We invest in our team's continuous learning and professional development.",
  },
];

export default ourValuesData;
